import {setupCanvas, getDPI} from "../common/components/utils";

function CircleChart(app, element, forcePaint) {

    const $chart = $(element)

    if(!$chart.length) return

    let dt = 0

    app.events.on('kx_repaint', (newDt) => {
        dt = newDt
        paint()
    })

    $(window).resize(paint)

    if (forcePaint) {
        paint()
    }

    function paint() {
        const $canvas = $chart.find( 'canvas' )
        const data = JSON.parse(decodeURIComponent($chart.attr('data-value')))

        // Setup canvas
        let ctx = setupCanvas($canvas.get(0), $chart)
        const h = ctx.canvas.height
        const w = ctx.canvas.width

        /*
         *  See more here
         *
         * // https://www.w3schools.com/tags/canvas_arc.asp
         */

        const limit = 2.0
        const offset = -0.5
        const thickness = 6.0 * getDPI()
        const radiusOuter = h / 2.0 - thickness / 2.0
        const originX = w / 2.0
        const originY = h / 2.0

        // Draw bg
        ctx.lineCap = 'round'
        ctx.strokeStyle = data['bg-color']
        ctx.lineWidth = thickness
        ctx.beginPath()
        ctx.arc(originX, originY, radiusOuter, 0, 2 * Math.PI)
        ctx.stroke()

        if(typeof data.value !== undefined) {
            // Draw fg
            ctx.strokeStyle = data['fg-color']
            ctx.beginPath()
            ctx.arc(originX, originY, radiusOuter, offset * Math.PI, (offset - limit * data.value) * Math.PI, true)
            ctx.stroke()

            // Draw text
            const fontsize = 2.0 * getDPI()
            ctx.font = fontsize+'rem campton'
            ctx.textAlign = 'center'
            ctx.textBaseline = 'middle'
            ctx.fillText((data.value * 100).toFixed(2) + '%', originX, originY)
        }
    }
}

function CircleTrafficChart(app) {

    CircleChart(app, '#circular-traffic-chart')

}

function HalfCircleChart(app) {
    const $chart = $( "#half-circular-chart" )
    if(!$chart.length) return
    let dt = 0
    app.events.on('kx_repaint', (newDt) => {
        dt = newDt
        paint()
    })
    $(window).resize(paint)

    function paint() {
        const $canvas = $chart.find( 'canvas' )
        const data = JSON.parse(decodeURIComponent($chart.data('value')))

        // Setup canvas
        let ctx = setupCanvas($canvas.get(0), $chart)
        const h = ctx.canvas.height
        const w = ctx.canvas.width

        /*
         *  See more here
         *
         * // https://www.w3schools.com/tags/canvas_arc.asp
         */
        const limit = 1.0
        const offset = -1
        const thickness = 6.0 * getDPI()
        const radiusOuter = h - thickness
        const originX = w / 2.0
        const originY = h - thickness / 2.0

        // Draw bg
        ctx.lineCap = 'round'
        ctx.strokeStyle = data['bg-color']
        ctx.lineWidth = thickness
        ctx.beginPath()
        ctx.arc(originX, originY, radiusOuter, offset * Math.PI, offset + limit)
        ctx.stroke()

        if(typeof data.value !== undefined) {
            // Draw fg
            ctx.strokeStyle = data['fg-color']
            ctx.beginPath()
            ctx.arc(originX, originY, radiusOuter, offset * Math.PI, (offset + data.value * limit) * Math.PI)
            ctx.stroke()

            // Draw text
            const fontsize = 2.0 * getDPI()
            ctx.font = fontsize+'rem campton'
            ctx.textAlign = 'center'
            ctx.textBaseline = 'middle'
            ctx.fillText((data.value * 100)+'%', originX, h * 0.7)
        }
    }
}

export default function(app) {

    $('.circular-chart').each((i, element) => {
        CircleChart(app, element)
    })

    HalfCircleChart(app)

    $('.circular-chart-refresh').on('change', function () {
        $('.circular-chart').each((i, element) => {
            CircleChart(app, element, true)
        })

        HalfCircleChart(app)
    });
}
